import React, { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, roles }) => {
  const { user, openAuth } = useAuth();
  const { t } = useLang();

  useEffect(() => {
    if (user === null) openAuth("login");
  }, [user]); // eslint-disable-line

  if (user === undefined) {
    return <div className="min-h-[60vh] grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-emerald-800" /></div>;
  }
  if (user === null) {
    return <div className="min-h-[60vh] grid place-items-center text-stone-500" data-testid="login-required">{t("login_required")}</div>;
  }
  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return <div className="min-h-[60vh] grid place-items-center text-stone-500">403 — {t("login_required")}</div>;
  }
  return children;
};
